// journal types
export const JournalTypes = {
  SALES: "sales",
  PURCHASE: "purchase",
  CASH: "cash",
  BANK: "bank",
  INCOME: "income",
  MISCELLANEOUS: "miscellaneous",
};

// chart of account
export const ChartOfAccounts = {
  NON_CURRENT_ASSET: "Non current asset",
  BANK_AND_CASH: "Bank and cash",
  FIXED_ASSET: "Fixed assets",
  CURRENT_ASSET: "Current asset",
  RECEIVABLES: "Receivables",
  PREPAYMENTS: "Prepayments",
  CURRENT_LIABILITY: "Current liability",
  NON_CURRENT_LIABILITY: "Non current liability",
  CREDIT_CARD: "Credit card",
  PAYABLE: "Payable",
  EQUITY: "Equity",
  CURRENT_YEAR_EARNINGS: "Current year earnings",
  INCOME: "Income",
  OTHER_INCOME: "Other Income",
  COST_OF_REVENUE: "Cost of revenue",
};

export const categoryOptions = {
  LEAVE_ENCASHMENT: "LEAVE ENCASHMENT",
  REIMBURSEMENTS: "REIMBURSEMENTS",
  BENEFITS: "BENEFITS",
  BONUS: "BONUS",
  ALLOWANCE: "ALLOWANCE",
  BASIC: "BASIC",
  COMMISSION: "COMMISSION",
  DEDUCTION: "DEDUCTION",
};

export const ACTION_TYPE = {
  ADD: "add",
  UPDATE: "update",
  DELETE: "delete",
};

export const VIEW_TYPE = {
  SINGLE: "single",
  LIST: "list",
};

export const calculationTypeOption = [
  { key: "Fixed", value: "FIXED", name: "fixed" },
  { key: "% CTC", value: "CTCPERCENT", name: "percentage of cost to company" },
  { key: "% BASIC", value: "BASICPERCENT", name: "percentage of basic" },
];
